import React from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';
import useMenuItems from 'gatsby-theme-menus/src/hooks/use-menu-items';
import Socials from '../../components/socials';
import NavItem from './nav-item';
import Nav from './nav';
import NavHeader from './nav-header';
import SocialsWrapper from './socials-wrapper';
import NavAddons from './nav-addons';

const Navigation = ({ menuIsOpen, toggleMenuOpen }) => {
  const { menuItems } = useMenuItems();
  return (
    <Nav menuIsOpen={menuIsOpen}>
      <NavHeader>
        <CloseButton onClick={toggleMenuOpen}>
          Sluiten
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 352 512"
          >
            <path
              fill="currentColor"
              d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
            />
          </svg>
        </CloseButton>
      </NavHeader>
      <NavUl>
        {menuItems?.map(({
          id,
          page,
          subpages,
          externalpage,
        }) => (page || externalpage) && (
          <NavItem
            key={id}
            label={externalpage?.externalTitle || page?.title}
            url={externalpage?.externalLink === '#' ? null : (externalpage?.externalLink || page?.slug)}
            partiallyActive
            subItems={subpages?.map((subpage) => ({
              label: subpage.title,
              url: subpage.slug,
              id: subpage.id,
            }))}
          />
        ))}
      </NavUl>
      <NavAddons />
      <SocialsWrapper>
        <hr />
        <h3>Volg mij</h3>
        <Socials />
      </SocialsWrapper>
    </Nav>
  );
};

const CloseButton = styled(Button).attrs({
  wrapper: true,
  nav: true,
  navType: 'hamburger_menu',
  eventAction: 'close',
  menuName: 'Main menu',
})`
  display: flex;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-weight: 700;
  color: ${(props) => props.theme.primaryColor};
  &:hover {
    color: ${(props) => props.theme.fontColor};
  }
  gap: 10px;

  svg {
    width: 20px;
    height: auto;
  }
`;

const NavUl = styled.ul`
  margin: 0;
  padding: 10px 0;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    padding: 0;
    display: flex;
  }
`;

export default Navigation;
